import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import '../../../assests/css/customer/UserPayments.css';

const UserPayment = () => {
  const [selectedPayment, setSelectedPayment] = useState('');
  
  // Load saved payment method on component mount
  useEffect(() => {
    const savedPaymentMethod = localStorage.getItem('preferredPaymentMethod');
    if (savedPaymentMethod) {
      setSelectedPayment(savedPaymentMethod);
    } else {
      setSelectedPayment('easypaisa'); // Default if no saved method
    }
  }, []);

  // Save payment method whenever it changes
  const handlePaymentSelection = (methodId) => {
    setSelectedPayment(methodId);
    localStorage.setItem('preferredPaymentMethod', methodId);
  };
  
  // Order items (using wishlist structure)
  const orderItems = [
    {
      id: 1,
      name: 'Sony WH-1000XM4 Wireless',
      quantity: 1,
      price: 45000,
      image: 'https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=400'
    },
    {
      id: 2,
      name: 'Silicone Case for iPhone 14',
      quantity: 2,
      price: 3500,
      image: 'https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=400'
    }
  ];

  const paymentMethods = [
    {
      id: 'easypaisa',
      name: 'EasyPaisa',
      description: 'Pay using EasyPaisa wallet or mobile number',
      badge: 'easypaisa',
      badgeColor: '#22c55e'
    },
    {
      id: 'jazzcash',
      name: 'JazzCash',
      description: 'Instant payment via JazzCash mobile account',
      badge: 'JazzCash',
      badgeColor: '#ef4444'
    },
    {
      id: 'card',
      name: 'Credit / Debit Card',
      description: 'Visa, Mastercard, or UnionPay',
      icon: '💳'
    },
    {
      id: 'bank',
      name: 'Direct Bank Transfer',
      description: 'Transfer directly to our bank account. Verification takes 24h.',
      icon: '🏦'
    },
    {
      id: 'cod',
      name: 'Cash on Delivery',
      description: 'Pay in cash when your order is delivered',
      icon: '💵'
    }
  ];

  // Calculate totals
  const subtotal = orderItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = 0; // Free
  const tax = 0;
  const totalPayable = subtotal + shipping + tax;

  const handleProceedToPay = () => {
    if (!selectedPayment) {
      alert('Please select a payment method');
      return;
    }
    console.log('Processing payment with:', selectedPayment);
    alert(`Processing payment via ${paymentMethods.find(p => p.id === selectedPayment)?.name}`);
    // Navigate to payment gateway or confirmation page
  };

  return (
    <div className="up-payment-container">
      <div className="up-payment-content">
        {/* Payment Methods */}
        <div className="up-payment-methods-section">
          <div className="up-payment-header">
            <h1 className="up-payment-title">Select Payment Method</h1>
            <p className="up-payment-subtitle">
              All transactions are secure and encrypted. Choose your preferred method below.
            </p>
          </div>

          <div className="up-payment-methods">
            {paymentMethods.map((method) => (
              <div
                key={method.id}
                className={`up-payment-method-card ${selectedPayment === method.id ? 'up-selected' : ''}`}
                onClick={() => handlePaymentSelection(method.id)}
              >
                <div className="up-payment-method-radio">
                  <div className={`up-radio-circle ${selectedPayment === method.id ? 'up-radio-selected' : ''}`}>
                    {selectedPayment === method.id && <div className="up-radio-dot"></div>}
                  </div>
                </div>

                <div className="up-payment-method-content">
                  <div className="up-payment-method-info">
                    <h3 className="up-payment-method-name">
                      {method.name} - {method.description}
                    </h3>
                  </div>
                  {method.badge ? (
                    <span 
                      className="up-payment-badge" 
                      style={{ backgroundColor: method.badgeColor }}
                    >
                      {method.badge}
                    </span>
                  ) : method.icon ? (
                    <span className="up-payment-icon-emoji">{method.icon}</span>
                  ) : null}
                </div>
              </div>
            ))}
          </div>

          <button className="up-proceed-btn" onClick={handleProceedToPay}>
            Proceed to Pay
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserPayment;